import React, { useEffect, useState } from "react";
import {Countries as countries} from "../../../../services/countries";
import Edit from "../../../../assets/images/editinput.svg";
import {Select} from "@appkit4/react-components/select"
import {Tooltip} from "@appkit4/react-components/tooltip"
import PropTypes from 'prop-types';

function GeneralInformation(props) {

  let {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    vendorAddressHandler,
    role,
    update
  } = props;

  const [departmentState, setDepartmentState] = useState([])
  const [valuesState, setValuesState] = useState({})
  const [selectFieldsDisabled, setSelectFieldsDisabled] = useState(false);

  useEffect(() => {
    setDepartmentState(props.departments)
    setValuesState(props.values)
  }, [props.departments, props.values])

  const dropdownData = [{
    value: 1,
    label: "On board"
  }, {
    value: 2,
    label: "Off board"
  }]

  let disabledFields;
  if (role === "analyst" || role === "manager") {
    disabledFields = true //Can be changed according to future requirement.
  }
  else {
    disabledFields = false //Can be changed according to future requirement.
  }
  let disabledFieldsStatus;
  if (role === "businessUser"){
    disabledFieldsStatus = true
  }
  else {
    disabledFieldsStatus = false
  }
  let disabledFieldsEdit;
  if (values.thirdPartyID !== 0) {
    disabledFieldsEdit = true;
  }
  else {
    disabledFieldsEdit = false;
  }
let disabledFieldsThirdPartyName;
  if (update === true) {
    disabledFieldsThirdPartyName = true;
  }
  else {
    disabledFieldsThirdPartyName = false;
  }

  return (
    <div>
      <div className="row m-0">
        <div className="col-sm-6">
          <div className={disabledFields || disabledFieldsStatus || selectFieldsDisabledn || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label">
              Status<span className="asterisk-required">*</span>
            </label>
            <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              searchable={true}
              className="cv-input-field"
              data={props.status}
              valueKey="status_id"
              labelKey="status_name"
              value={values.status}
              onSelect={(e) => handleChange("status")({ target: { value: e } })}
              name="status"
              placeholder="Select Status"
              disabled={role === "businessUser" ? disabledFieldsStatus : disabledFields}
            >
            </Select>
          </div>
          {errors.status && touched.status && (
            <div className="form-label error">{errors.status}</div>
          )}
        </div>

        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label">
              Requested By<span className="asterisk-required">*</span>
            </label>
            <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              searchable={true}
              className="cv-input-field"
              data={props.requestedBy}
              valueKey="user_id"
              labelKey="user_name"
              value={values.requestedBy}
              onSelect={(e) =>
                handleChange("requestedBy")({ target: { value: e } })
              }
              name="requestedBy"
              placeholder="Select Requested By"
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit}
            >
            </Select>
          </div>
          {errors.requestedBy && touched.requestedBy && (
            <div className="form-label error">{errors.requestedBy}</div>
          )}
        </div>
      </div>
      <div className="row m-0">
        <div className="col-sm-6">
          <div className={disabledFields || disabledFieldsThirdPartyName ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label">
              Third Party Name<span className="asterisk-required">*</span>
            </label>
            {values.thirdPartyID !== 0 ? (
              <Select
                showSearchOnToggle={true}
                dropdownRenderMode="portal"
                searchable={true}
                className="cv-input-field"
                data={props.vendors}
                labelKey="vendor_name"
                valueKey="vendor_id"
                value={values.thirdPartyID}
                placeholder={"Select/Add New Third Party"}
                onSelect={(e) => {
                  setSelectFieldsDisabled(e !== 0 ? true : false); 
                  vendorAddressHandler(e);
                  handleChange("thirdPartyID")({ target: { value: e } });
                }}
                name="thirdPartyID"
                disabled={disabledFields || disabledFieldsThirdPartyName}
              >
              </Select>
            ) : (
              <>
                <input
                  className="cv-input-field leftPadding"
                  type="text"
                  value={values.thirdPartyName}
                  onChange={handleChange("thirdPartyName")}
                  name="thirdPartyName"
                  placeholder="Add New Third Party"
                  disabled={disabledFields}
                ></input>
                <span
className="Appkit4-icon icon-right-chevron-fill pointer"
                  title="Select Existing Third Party"
                  onClick={(e) =>
                    handleChange("thirdPartyID")({ target: { value: null } })
                  }
                ></span>
              </>
            )}
          </div>
          {errors.thirdPartyName && touched.thirdPartyName && (
            <div className="form-label error">{errors.thirdPartyName}</div>
          )}
          {errors.thirdPartyID && touched.thirdPartyID && (
            <div className="form-label error">{errors.thirdPartyID}</div>
          )}
        </div>
        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label">Department<span className="asterisk-required">*</span></label>
            <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              searchable={true}
              className="cv-input-field"
              data={departmentState}
              valueKey="vendor_department_id"
              labelKey="vendor_department_name"
              value={valuesState.department}
              onSelect={(e) =>
                handleChange("department")({ target: { value: e } })
              }
              name="department"
              placeholder="Select Department"
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit }
            >
            </Select>
          </div>
          {errors.department && touched.department && (
            <div className="form-label error">{errors.department}</div>
          )}
        </div>
      </div>

      <div className="row m-0">
        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label">Sub - Department<span className="asterisk-required">*</span></label>
            <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              searchable={true}
              className="cv-input-field"
              data={props.subDepart}
              valueKey="vendor_subdepartent_id"
              labelKey="vendor_subdepartment_name"
              value={values.subDepartment}
              onSelect={(e) =>
                handleChange("subDepartment")({ target: { value: e } })
              }
              name="subDepartment"
              placeholder="Select Sub - Department"
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit }
            >
            </Select>
          </div>
          {errors.subDepartment && touched.subDepartment && (
            <div className="form-label error">{errors.subDepartment}</div>
          )}
        </div>

        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label htmlFor="TotalContractValueGeneral" className="cv-input-label ">Total Contract Value<span className="asterisk-required">*</span></label>
            <input
              className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
              onBlur={handleBlur}
              id="TotalContractValueGeneral"
              type="number"
              value={values.totalContractValue}
              onChange={handleChange("totalContractValue")}
              name="totalContractValue"
              placeholder="Select Total Contract Value"
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit }
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.totalContractValue && touched.totalContractValue && (
            <div className="form-label error">{errors.totalContractValue}</div>
          )}
        </div>
      </div>
      <div className="row m-0">
        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label" aria-label="Close">
              
              Countries of Business<Tooltip content="Select Countries of Business " position="right"> Countries of Business<span className="asterisk-required">*</span></Tooltip>
            </label>
            <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              searchable={true}
              placeholder="Select Countries of Business"
              className="cv-input-field"
              multiple
              data={countries}
              valueKey="code"
              labelKey="name"
              name="countryOfBusiness"
              onSelect={(e) =>
                handleChange("countryOfBusiness")({ target: { value: e } })
              }
              value={values.countryOfBusiness}
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit }
            >
            </Select>
          </div>
          {errors.countryOfBusiness && touched.countryOfBusiness && (
            <div className="form-label error">{errors.countryOfBusiness}</div>
          )}
        </div>
        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label">Boarding<span className="asterisk-required">*</span></label>
            <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              searchable={true}
              className="cv-input-field"
              data={dropdownData}
              value={Number(values.boarding)}
              onSelect={(e) =>
                handleChange("boarding")({ target: { value: e } })
              }
              name="boarding"
              placeholder="Select Boarding Type"
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit }
            >
            </Select>
          </div>
          {errors.boarding && touched.boarding && (
            <div className="form-label error">{errors.boarding}</div>
          )}
        </div>
      </div>
    </div>
  );
}
GeneralInformation.propTypes = {
  values: PropTypes.object,
  touched:PropTypes.object,
  errors:PropTypes.object,
  handleChange:PropTypes.func,
  handleBlur:PropTypes.func,
  vendorAddressHandler:PropTypes.func,
  role:PropTypes.string,
  status:PropTypes.array,
  requestedBy:PropTypes.array,
  vendors:PropTypes.array,
  subDepart:PropTypes.array,
  departments:PropTypes.array
}
export default GeneralInformation;
